import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react";
import { useEffect, useState, cloneElement, useMemo, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CustomButton } from '../../../components/customButton/CustomButton';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { styled } from '@mui/material/styles';
import { STEPS } from './steps';
import './contrato.scss';
import { adaptEstadosEvolucionAsistArray, GET_ESTADOS_MEDICO } from '../../../data/graphQL/queries/Contratos/EvaluacionAsistencial/getEstadosMedico';
import { GET_TIPO_MODULOS, adaptTipoModulosArray } from '../../../data/graphQL/queries/Contratos/DatosPrincipales/getTipoModulos';
import toast from 'react-hot-toast';
import { VALIDATE_CONTRATO } from '../../../data/graphQL/mutations/Contratos/validateContrato';
import { EXISTE_NUMERO_SEGUIMIENTO } from '../../../data/graphQL/queries/Contratos/existeNumeroSeguimiento';
import { VALIDAR_MODULO_RI } from '../../../data/graphQL/queries/Contratos/validarModuloRI';
import { EXISTE_AUTORIZACION } from '../../../data/graphQL/queries/Contratos/existeAutorizacion';
import { DateDiff } from '../../../utils/helpers';
import { adaptRequisitoCliente, GET_REQUISITO_CLIENTE } from "../../../data/graphQL/queries/Contratos/DatosPrincipales/getRequisitoClienteByClienteId";
import { GET_ESTADO_EVALUACION_BY_ID } from '../../../data/graphQL/queries/Contratos/DatosPrincipales/getEstadoEvaluacionById';
import moment from 'moment';

export const LUGAR_RI_DOMICILIO_ID = 1;
export const LUGAR_RI_INTERNACION_ID = 2;

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const validPhoneRegex = /^\+[0-9]{10,15}$/;

const AntTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    backgroundColor: '#52BA50'
  },
  '& .MuiTabs-scrollButtons.Mui-disabled': {
    opacity: '0.3'
  }
});

const AntTab = styled((props) => <Tab {...props} />)(({ theme }) => ({
  textTransform: 'none',
  minWidth: 0,
  [theme.breakpoints.up('sm')]: {
    minWidth: 0
  },
  fontWeight: theme.typography.fontWeightRegular,
  color: 'black',
  '&:hover': {
    color: '#52BA50',
    opacity: 1
  },
  '&.Mui-selected': {
    color: '#52BA50',
    fontWeight: 600
  },
  '&.Mui-focusVisible': {
    backgroundColor: '#d1eaff'
  }
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role='tabpanel'
      // hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>

      <Box sx={{ display: value === index ? 'block' : 'none' }}>
        {children}
      </Box>
    </div>);

}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

const ESTADO_EVALUACION_SERVICIO = 5;

export const RESULTADO_PRESUPUESTO_APROBADO = 1;

export const Contrato = ({ setChildrenAction, setHeaderContent }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const stateData = location.state;
  const dataSubmissionRef = useRef(null);
  const debounceRef = useRef(null);
  const refetchGestionPresupuestoRef = useRef(null);
  const phoneRegex = /^\+54(9\d{10}|\d{10,11})$/;

  const [isClientAuthNumeric, setIsClientAuthNumeric] = useState(false);
  const [isClientAuthDigital, setIsClientAuthDigital] = useState(false);

  const [tipoModulo, setTipoModulo] = useState([]);
  const [estadosCrediticia, setEstadosCrediticia] = useState([]);

  const [currentStep, setCurrentStep] = useState(0);
  const [fullFormData, setFullFormData] = useState({
    datosPrincipales: {},
    condicionesContrato: {},
    gestionCrediticia: {},
    gestionPresupuestos: {},
    evaluacionAsistencial: {}
  });

  const [requisitoCliente, setRequisitoCliente] = useState({});

  const [origenContrato, setOrigenContrato] = useState(stateData.origen);

  const [estadosEvolucionAsist, setEstadosEvolucionAsist] = useState([]);

  const [guardarLoading, setGuardarLoading] = useState();
  const [pageLoading, setPageLoading] = useState(true);

  const [isDistinctDelegacion, setIsDistinctDelegacion] = useState(false);

  const [motivosNoIngreso, setMotivosNoIngreso] = useState([]);

  const [cambioDireccion, setCambioDireccion] = useState(false);

  const idEvaluacion = useMemo(() =>
    fullFormData?.datosPrincipales?.idEvaluacion ??
    stateData?.idEvaluacion ??
    0,
    [stateData?.idEvaluacion, fullFormData?.datosPrincipales?.idEvaluacion]);

  const [getEstadoEvaluacion, { data: dataEstadoEvaluacion }] = useLazyQuery(GET_ESTADO_EVALUACION_BY_ID, {
    fetchPolicy: 'no-cache',
    skip: !idEvaluacion
  });

  useEffect(() => {
    if (!dataEstadoEvaluacion) return;
    const nuevoEstado = dataEstadoEvaluacion?.evaluacionById?.evaluacion?.idEstadoEvaluacionNavigation?.descripcion ||
      stateData?.descEstadoEvaluacion ||
      'Pendiente';

    if ((nuevoEstado === 'Servicio' || nuevoEstado === 'Aprobado' || nuevoEstado === 'Rechazado') && nuevoEstado !== stateData?.descEstadoEvaluacion) {
      navigate('/contratos');
    } else {
      navigate('/contratos/crearContrato', {
        state: { ...stateData, descEstadoEvaluacion: nuevoEstado },
        replace: true
      });
    }
  }, [dataEstadoEvaluacion]);

  const { data: dataTipoModulo } = useQuery(GET_TIPO_MODULOS, {
    fetchPolicy: 'no-cache'
  }, []);

  useEffect(() => {
    if (!dataTipoModulo) return;
    setTipoModulo(adaptTipoModulosArray(dataTipoModulo?.allTipoModulo));
  }, [dataTipoModulo]);

  const { data: dataEstadosMedico } = useQuery(GET_ESTADOS_MEDICO);

  useEffect(() => {
    if (!dataEstadosMedico) return;
    setEstadosEvolucionAsist(adaptEstadosEvolucionAsistArray(dataEstadosMedico));
  }, [dataEstadosMedico]);

  const [existNumeroSeguimiento, { data: dataExistNumeroSeguimiento }] = useLazyQuery(EXISTE_NUMERO_SEGUIMIENTO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataExistNumeroSeguimiento) return;
    return dataExistNumeroSeguimiento;
  }, [dataExistNumeroSeguimiento]);

  const [validarNroRI, { data: dataValidarNroRI }] = useLazyQuery(VALIDAR_MODULO_RI, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataValidarNroRI) return;
    return dataValidarNroRI;
  }, [dataValidarNroRI]);

  const [existeAutorizacion, { data: dataExisteAutorizacion }] = useLazyQuery(EXISTE_AUTORIZACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataExisteAutorizacion) return;
    return dataExisteAutorizacion;
  }, [dataExisteAutorizacion]);

  const [getRequisitoCliente, { data: dataRequisitoCliente }] = useLazyQuery(GET_REQUISITO_CLIENTE, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataRequisitoCliente) return;
    if (dataRequisitoCliente?.requisitoClienteByClienteId !== null) {
      setRequisitoCliente(adaptRequisitoCliente(dataRequisitoCliente?.requisitoClienteByClienteId));
    }
  }, [dataRequisitoCliente]);

  useEffect(() => {
    if (fullFormData?.datosPrincipales?.idCliente) {
      getRequisitoCliente({ variables: { codCliente: fullFormData?.datosPrincipales?.idCliente } });
    }
  }, [fullFormData?.datosPrincipales?.idCliente]);

  const validarDatosPrincipales = () => {
    let errorMessages = [];
    if (stateData?.edit) {
      if (fullFormData?.datosPrincipales.telefonoContacto && !phoneRegex.test(fullFormData?.datosPrincipales.telefonoContacto.trim())) {
        errorMessages.push('Debe ingresar un télefono de contacto completo con código de país. Ej: +541123456789.\n');
      }

      if (fullFormData?.datosPrincipales.familiarTelefono && !phoneRegex.test(fullFormData?.datosPrincipales.familiarTelefono.trim())) {
        errorMessages.push('Debe ingresar un télefono de familiar completo con código de país. Ej: +541123456789.\n');
      }
    }

    if (errorMessages.length > 0) {
      toast.error(errorMessages.join(' '));
      return false;
    }

    return true;
  }

  const handleChangeTab = async (_, newValue) => {
    if (validarDatosPrincipales()) {
      const callbackTabName = STEPS.find((x) => x.order === currentStep + 1)?.stepKey;
      const stepCallback = dataSubmissionRef.current[callbackTabName];

      if (stepCallback && stateData?.edit) {
        const callbackFn = stepCallback?.callback || stepCallback;

        if (typeof callbackFn === 'function') {
          await callbackFn(); // por si es async
        }
      }

      setCurrentStep(newValue);
    }
  };

  // Fuera del componente — funciones puras de validación, una responsabilidad cada una

  const tieneCamposBasicosValidos = (datos) => {
    const { nombre, apellido, fechaNacimiento, sexo, idLugarServicio, idCliente, idTipoModulo } = datos;
    return !!(
      nombre?.trim() &&
      apellido?.trim() &&
      fechaNacimiento &&
      sexo?.trim() &&
      idLugarServicio &&
      idCliente &&
      idTipoModulo
    );
  };

  const tieneFormatoInvalido = (datos) => {
    const { mail, telefonoContacto } = datos;
    if (mail && !emailRegex.test(mail)) return true;
    if (telefonoContacto && !validPhoneRegex.test(telefonoContacto)) return true;
    return false;
  };

  const requiereContactoTelemedicina = (datos, requisitoCliente) => {
    const { mail, telefonoContacto } = datos;
    return !!(requisitoCliente?.telemedicina && !mail && !telefonoContacto);
  };

  const tieneDocumentoInvalido = (datos) => {
    const { sinDoc, idTipoDocumento, numeroDocumento } = datos;
    return !sinDoc && (!idTipoDocumento || idTipoDocumento === 0 || !numeroDocumento?.trim());
  };

  const tieneInstitucionSinCanal = (datos, origenContrato) => {
    const { idInstitucion, idCanal } = datos;
    return !!idInstitucion && idCanal == 0 && origenContrato == 'PP';
  };

  const requiereCentroReferenciaFaltante = (datos) => {
    const { idTipoModulo, idCentroReferencia } = datos;
    return [2, 10, 14].includes(idTipoModulo) && (!idCentroReferencia || idCentroReferencia === 0);
  };

  const requiereDerivacionFaltante = (datos, tipoModulo, origenContrato) => {
    const { idTipoModulo, derivacionPrescriptor } = datos;
    const tipoModuloSeleccionado = tipoModulo.find((x) => x.id === idTipoModulo);
    return !!(tipoModuloSeleccionado?.rp && !derivacionPrescriptor && origenContrato != 'PR');
  };

  // Función orquestadora — combina las validaciones anteriores
  const esDatosPrincipalesInvalido = (datos, contexto) => {
    const { requisitoCliente, tipoModulo, origenContrato } = contexto;

    const validacionesDeFallo = [
      !tieneCamposBasicosValidos(datos),
      tieneFormatoInvalido(datos),
      requiereContactoTelemedicina(datos, requisitoCliente),
      tieneDocumentoInvalido(datos),
      tieneInstitucionSinCanal(datos, origenContrato),
      requiereCentroReferenciaFaltante(datos),
      requiereDerivacionFaltante(datos, tipoModulo, origenContrato),
    ];

    return validacionesDeFallo.some(Boolean);
  };

  // Dentro del componente:
  const disabledTabs = useMemo(() => {
    const isDatosPrincipalesValid = (datosPrincipales) => {
      if (!datosPrincipales || idEvaluacion == 0) return false;

      return !esDatosPrincipalesInvalido(datosPrincipales, {
        requisitoCliente,
        tipoModulo,
        origenContrato,
      });
    };

    const isDireccionPacienteValid = (direccionPaciente) => {
      if (!direccionPaciente) return false; // Validar si es undefined o null

      const {
        codigoSAP,
        idLugarRI
      } = direccionPaciente;

      // if (!codigoSAP?.trim() || !idLugarRI) return false;
      if (!codigoSAP?.trim()) return false;

      //Futruas validaciones 

      return true;
    };

    const isGestionInicioEnabled = (datosPrincipales) => {
      if (!datosPrincipales) return true; // Validar si es undefined o null

      const {
        nombre,
        apellido,
        sinInstitucion,
        idInstitucion
      } = datosPrincipales;

      if (!nombre?.trim() || !apellido?.trim() || !sinInstitucion && !idInstitucion) return true;

      return false;
    };

    return {
      datosPrincipales: false,
      direccionPaciente: !isDatosPrincipalesValid(fullFormData?.datosPrincipales) && stateData?.edit,
      gestionCrediticia: !isDireccionPacienteValid(fullFormData?.direccionPaciente) && stateData?.edit,
      evaluacionAsistencial: !isDireccionPacienteValid(fullFormData?.direccionPaciente) && stateData?.edit,
      condicionesContrato: !isDireccionPacienteValid(fullFormData?.direccionPaciente) && stateData?.edit,
      gestionPresupuestos: (!isDireccionPacienteValid(fullFormData?.direccionPaciente) || !fullFormData?.evaluacionAsistencial?.idModulo) && stateData?.edit,
      gestionInicio: isGestionInicioEnabled(fullFormData?.datosPrincipales) && stateData?.edit,
      documentacion: !isDireccionPacienteValid(fullFormData?.direccionPaciente) && stateData?.edit,
      allTabs: (!isDatosPrincipalesValid(fullFormData?.datosPrincipales) || isDistinctDelegacion || pageLoading) && stateData?.edit
    };
  }, [fullFormData?.datosPrincipales, fullFormData?.direccionPaciente, fullFormData?.evaluacionAsistencial?.idModulo, pageLoading, idEvaluacion]);

  const [validateContrato, { loading: validateContratoLoading }] = useMutation(VALIDATE_CONTRATO, {
    variables: {
      idEvaluacion
    },
    onCompleted: (data) => {
      getEstadoEvaluacion({ variables: { idEvaluacion: idEvaluacion }, });
      const response = data?.validateEvaluacion;
      if (response.includes('Contrato validado')) {
        toast.success(response);
        navigate('/contratos');
      } else {
        toast(response, {
          icon: 'ℹ️',
          style: {
            background: '#f0f4ff',
            color: '#333'
          }
        });
      }
    },
    onError: (data) => {
      setGuardarLoading(false);
    }
  });

  const construirValidacionesDatosPrincipales = (datosPrincipales, contexto) => {
    const { requisitoCliente, tipoModulo, origenContrato } = contexto;

    return [
      {
        condition: requiereContactoTelemedicina(datosPrincipales, requisitoCliente),
        message: 'Debe ingresar Email o Teléfono del paciente.\n',
      },
      {
        condition: datosPrincipales.telefonoContacto && !validPhoneRegex.test(datosPrincipales.telefonoContacto),
        message: 'Debe ingresar un Teléfono de contacto del paciente válido.\n',
      },
      { condition: !datosPrincipales.fechaNacimiento, message: 'Debe ingresar la fecha de nacimiento.\n' },
      { condition: !datosPrincipales.sexo?.trim(), message: 'Debe ingresar el sexo.\n' },
      { condition: !datosPrincipales.idLugarServicio, message: 'Debe ingresar el lugar de servicio.\n' },
      { condition: !datosPrincipales.idCliente, message: 'Debe ingresar el financiador SAP.\n' },
      { condition: !datosPrincipales.idTipoModulo, message: 'Debe ingresar el programa.\n' },
      {
        condition: !datosPrincipales.sinDoc && (!datosPrincipales.idTipoDocumento || datosPrincipales.idTipoDocumento === 0),
        message: 'Debe ingresar el tipo de documento.\n',
      },
      {
        condition: !datosPrincipales.sinDoc && !datosPrincipales.numeroDocumento?.length,
        message: 'Debe ingresar el número de documento.\n',
      },
      {
        condition: requiereDerivacionFaltante(datosPrincipales, tipoModulo, origenContrato),
        message: 'Debe adjuntar un RP.\n',
      },
      {
        condition: requiereCentroReferenciaFaltante(datosPrincipales),
        message: 'Debe ingresar el centro de referencia.\n',
      },
      {
        condition: tieneInstitucionSinCanal(datosPrincipales, origenContrato),
        message: 'Debe ingresar el canal.\n',
      },
    ];
  };

  // Función original, ahora mucho más simple
  const informarDatosPrincipales = () => {
    const { datosPrincipales } = fullFormData;

    const validaciones = construirValidacionesDatosPrincipales(datosPrincipales, {
      requisitoCliente,
      tipoModulo,
      origenContrato,
    });

    const errorMessages = validaciones
      .filter(({ condition }) => condition)
      .map(({ message }) => message);

    if (datosPrincipales.mail) {
      errorMessages.push(...validarEmails(datosPrincipales.mail));
    }

    if (errorMessages.length > 0) {
      toast('Para continuar: \n' + errorMessages.join(' '), {
        icon: 'ℹ️',
        style: {
          background: '#f0f4ff',
          color: '#333',
        },
      });
    }
  };

  // Función auxiliar para validar emails
  const validarEmails = (mailString) => {
    const errores = [];
    const emails = mailString.split(';').map(email => email.trim()).filter(email => email.length > 0);

    if (emails.length > 2) {
      errores.push('Puede ingresar máximo 2 emails separados por ";".\n');
    } else {
      const emailsInvalidos = emails.filter(email => !emailRegex.test(email));
      if (emailsInvalidos.length > 0) {
        errores.push('Debe ingresar emails válidos. Emails inválidos: ' + emailsInvalidos.join(', ') + '\n');
      }
    }

    return errores;
  };

  // Función pura — ejecuta el callback del paso actual y devuelve si hubo error
  const ejecutarCallbackDelPaso = async (currentStepCallback) => {
    if (!currentStepCallback) return false;

    const ejecutar = currentStepCallback.callback || currentStepCallback;
    const result = await ejecutar();

    return !!result?.error;
  };

  // Función pura — decide qué acción de post-guardado corresponde según el paso
  const finalizarGuardadoDelPaso = async (stepKey, contexto) => {
    const { informarDatosPrincipales, validateContrato } = contexto;

    if (stepKey === 'datosPrincipales') {
      informarDatosPrincipales();
      return;
    }
    await validateContrato();
  };

  const handleGuardar = async () => {
    setGuardarLoading(true);
    try {
      const stepKey = STEPS[currentStep].stepKey;
      const currentStepCallback = dataSubmissionRef.current[stepKey];

      const extraValidacionOK = currentStepCallback?.validar
        ? await currentStepCallback.validar()
        : true;

      if (!extraValidacionOK || !isFormValid()) return;

      const hasError = await ejecutarCallbackDelPaso(currentStepCallback);

      if (!hasError) {
        await finalizarGuardadoDelPaso(stepKey, { informarDatosPrincipales, validateContrato });
      }
    } finally {
      setGuardarLoading(false);
    }
  };

  useEffect(() => {
    const fechaContrato = !Boolean(fullFormData?.condicionesContrato?.fechaDesde && fullFormData?.condicionesContrato?.fechaHasta) ? null :
      `${moment(fullFormData?.condicionesContrato?.fechaDesde).format('DD/MM/YYYY')} - ${moment(fullFormData?.condicionesContrato?.fechaHasta).format('DD/MM/YYYY')}`;

    setChildrenAction(() =>
      <div className='header-actions-contrato'>
        <div className='chip-numero-contrato'>
          {(!idEvaluacion || idEvaluacion <= 0) && <p>N. de contrato: <strong>{idEvaluacion}{Boolean(stateData?.delegacion) && ` | ${stateData?.delegacion} `}</strong> </p>}
          {idEvaluacion > 0 && <p>N. de contrato: <strong>{idEvaluacion}{Boolean(stateData?.delegacion) && ` | ${stateData?.delegacion} | ${stateData?.descEstadoEvaluacion || 'Pendiente'}`}{Boolean(fechaContrato) && ` | ${fechaContrato}`}</strong> </p>}
        </div>
        {stateData?.edit && <div className='header-plan-cuidado'>
          <CustomButton
            size='small'
            isLoading={guardarLoading || validateContratoLoading}
            disabled={isDistinctDelegacion || guardarLoading || validateContratoLoading}
            onClick={handleGuardar}>

            Guardar
          </CustomButton>
        </div>}
      </div>
    );
    setHeaderContent(() =>
      <AntTabs
        value={currentStep}
        onChange={handleChangeTab}
        variant='scrollable'
        scrollButtons='auto'
        aria-label='Tabs Contratos'>

        {STEPS.map((step, index) =>
          <AntTab
            key={step.stepKey}
            disabled={disabledTabs[step.stepKey] || step.stepKey !== 'datosPrincipales' && step.stepKey !== 'gestionInicio' && disabledTabs.allTabs}
            label={step.stepName}
            {...a11yProps(index)} />

        )}
      </AntTabs>
    );
  }, [
    setChildrenAction,
    setHeaderContent,
    currentStep,
    idEvaluacion,
    stateData,
    disabledTabs,
    validateContratoLoading,
    guardarLoading,
    isDistinctDelegacion,
    fullFormData]
  );

  const handleChangeFullFormData = (name, value) => {
    setFullFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const handleChangeDireccionPaciente = (value) => {
    setFullFormData((prevFormData) => {
      const updatedDireccionPaciente = { ...prevFormData.direccionPaciente, ...value };
      return {
        ...prevFormData,
        direccionPaciente: updatedDireccionPaciente
      };
    });
  };

  const ValidarPresupuestoAprobado = async (e) => {
    const { data: existNroSeguimiento } = await existNumeroSeguimiento({
      variables: {
        idCliente: fullFormData.datosPrincipales.idCliente,
        numeroSeguimiento: fullFormData.gestionPresupuestos.numeroAprobacionPresupuesto,
        idPaciente: fullFormData.datosPrincipales.idPaciente
      }
    });

    const { data: existAutorizacion } = await existeAutorizacion({
      variables: {
        idEvaluacion: idEvaluacion
      }
    });

    const { data: valNroRI } = await validarNroRI({
      variables: {
        idPlanCuidado: fullFormData?.datosPrincipales?.idCliente
      }
    });

    switch (requisitoCliente?.idTipoAutorizacion) {
      case "0":
        if (existNroSeguimiento.existNumeroSeguimiento) {
          toast.error('Debe ingresar el nro de seguimiento y ser único para el cliente.');
          return false;
        }
        break;
      case "1":
        if (!existAutorizacion.valorEsperado) {
          toast.error('No se encuentra la autorizacion del contrato.');
          return false;
        }
        break;
      case "2":
        if (existNroSeguimiento.existNumeroSeguimiento) {
          toast.error('Debe ingresar el nro de seguimiento y ser único para el cliente.');
          return false;
        } else
          if (!existeAutorizacion.valorEsperado) {
            toast.error('No se encuentra la autorizacion del contrato.');
            return false;
          }
        break;
      case "3":
        if (existNroSeguimiento.existNumeroSeguimiento) {
          toast.error('Debe ingresar el nro de seguimiento y ser único para el cliente.');
          return false;
        }
    }

    if (requisitoCliente?.bloqueoEnvio) {
      toast.error('El contrato no puede aprobarse, porque el cliente está bloqueado.');
      return false;
    }

  };

  const ValidarPresupuestoRechazado = () => {
    let gestionInicio = fullFormData.gestionInicio;

    if (gestionInicio != undefined) {
      if (gestionInicio.idNIngreso == 0) {
        toast.error('Usted debe ingresar el motivo de no ingreso.');
        return false;
      }
      if (gestionInicio.idRechazoNIngreso == 0) {
        toast.error('Usted debe ingresar el rechazo de no ingreso.');
        return false;
      }
      if (gestionInicio.fechaNIngreso.length == 0) {
        toast.error('Usted debe ingresar la fecha de no ingreso.');
        return false;
      }
      if (gestionInicio.observacionNIngreso.length == 0) {
        toast.error('Usted debe ingresar las observaciones de no ingreso.');
        return false;
      }
    }

  };

  const diferenciaDias = useMemo(() => {
    return moment(fullFormData?.gestionInicio?.fechaInicioServicio).diff(moment(fullFormData?.condicionesContrato?.fechaDesde), 'days');
  }, [fullFormData?.gestionInicio?.fechaInicioServicio, fullFormData?.condicionesContrato?.fechaDesde]);

  // Funciones puras — una por bloque de validación, mismo patrón que ya usamos antes

  const validarMotivoDemora = (contexto) => {
    const { origenContrato, stateData, diferenciaDias, gestionInicio } = contexto;
    const requiereMotivo =
      origenContrato == 'PP' &&
      stateData.idEstadoEvaluacion === ESTADO_EVALUACION_SERVICIO &&
      diferenciaDias > 8 &&
      !gestionInicio?.idMDemora;

      return requiereMotivo ? ['Debe indicar un Motivo de demora.\n'] : [];
  };

  const validarMotivoNoIngreso = (contexto) => {
    const { origenContrato, gestionInicio, condicionesContrato, motivosNoIngreso } = contexto;

    const aplica =
      origenContrato == 'PP' &&
      !gestionInicio?.fechaInicioServicio &&
      moment(condicionesContrato.fechaHasta).isBefore(moment());

    if (!aplica) return [];

    const mensajes = [];
    if (!gestionInicio?.idNIngreso) {
      mensajes.push('Debe indicar un Motivo de no ingreso.\n');
    }

    const motivoFallecimientoId = motivosNoIngreso?.find((x) => x.displayName.includes('FALLECIO'))?.id;
    if (gestionInicio?.idNIngreso !== motivoFallecimientoId && !gestionInicio?.idRechazoNIngreso) {
      mensajes.push('Debe indicar un rechazo.\n');
    }

    return mensajes;
  };

  // Una función pura por paso — reciben solo la porción de datos que necesitan

  const validarDatosPrincipalesStep = (datosPrincipales) => {
    if (datosPrincipales === undefined) return [];

    const validaciones = [
      { condition: !datosPrincipales.nombre || datosPrincipales?.nombre.length === 0, message: 'Debe ingresar el nombre del paciente.\n' },
      { condition: !datosPrincipales.apellido || datosPrincipales?.apellido.length === 0, message: 'Debe ingresar el apellido del paciente.\n' },
    ];

    return validaciones.filter((v) => v.condition).map((v) => v.message);
  };

  const validarCondicionesContratoStep = (condicionesContrato) => {
    if (condicionesContrato === undefined) return [];

    const mensajes = [];

    if (!condicionesContrato.fechaDesde || !condicionesContrato.fechaHasta) {
      mensajes.push('Usted debe indicar la fecha desde y hasta del contrato.\n');
    }

    if (condicionesContrato.cotizado) {
      const dias = DateDiff(new Date(condicionesContrato.fechaDesde), new Date(condicionesContrato.fechaHasta));
      //Se valida con 91 días porque el último día se contea como parte del contrato
      //y el contrato no puede ser mayor a 92 días.
      if (dias > 91) {
        mensajes.push('Los contratos cotizados se deberán limitar a solo 92 días de largo.\n');
      }
    }

    if (!condicionesContrato.cotizado && condicionesContrato.precioDiario <= 0) {
      mensajes.push('Usted debe indicar un precio diario mayor a cero.\n');
    }

    return mensajes;
  };

  const validarEvaluacionAsistencialStep = (evaluacionAsistencial) => {
    if (evaluacionAsistencial === undefined) return [];
    return evaluacionAsistencial.idModulo == 0 ? ['Debe indicar un plan de cuidado.\n'] : [];
  };

  // Gestión crediticia y presupuestos no tienen validaciones aún, pero se dejan
  // como funciones para mantener el mismo mapa de steps y facilitar agregar reglas después.
  const validarGestionCrediticiaStep = () => [];
  const validarGestionPresupuestosStep = () => [];
  const validarGestionInicioStep = () => [];

  // Mapa de step -> función de validación, evita el switch con ifs anidados
  const construirValidadoresPorStep = (fullFormData) => ({
    datosPrincipales: () => validarDatosPrincipalesStep(fullFormData.datosPrincipales),
    condicionesContrato: () => validarCondicionesContratoStep(fullFormData.condicionesContrato),
    gestionCrediticia: () => validarGestionCrediticiaStep(),
    gestionPresupuestos: () => validarGestionPresupuestosStep(),
    evaluacionAsistencial: () => validarEvaluacionAsistencialStep(fullFormData.evaluacionAsistencial),
    gestionInicio: () => validarGestionInicioStep(),
  });

  // Función original, ahora una simple orquestación
  const isFormValid = () => {
    const currentStepKey = STEPS[currentStep].stepKey;
    const { condicionesContrato, gestionInicio } = fullFormData;

    const validadoresPorStep = construirValidadoresPorStep(fullFormData);
    const validarStepActual = validadoresPorStep[currentStepKey];

    if (!validarStepActual) return true;

    const errorMessages = [
      ...validarMotivoDemora({ origenContrato, stateData, diferenciaDias, gestionInicio }),
      ...validarMotivoNoIngreso({ origenContrato, gestionInicio, condicionesContrato, motivosNoIngreso }),
      ...validarStepActual(),
    ];

    if (errorMessages.length > 0) {
      toast.error(errorMessages.join(' '));
      return false;
    }

    return true;
  };

  return (
    <div className='general'>
      {STEPS.map((step, index) =>
        <TabPanel key={index} value={currentStep} index={index}>
          {cloneElement(step?.component || <></>, {
            setDataSubmissionCallback: (callback) => {
              dataSubmissionRef.current = {
                ...dataSubmissionRef.current,
                [step.stepKey]: callback
              };
            },
            dataSubmissionRef,
            contratoEditable: stateData?.edit,
            stepData: step,
            fullFormData,
            handleChangeFullFormData: (name, formValue) => handleChangeFullFormData(name, formValue),
            handleChangeDireccionPaciente,
            programaRI: tipoModulo?.find((x) => x.id === fullFormData?.datosPrincipales?.idTipoModulo)?.abreviacion,
            tipoModuloSelected: tipoModulo?.find((x) => x.id === fullFormData?.datosPrincipales?.idTipoModulo),
            idPaciente: fullFormData?.datosPrincipales?.idPaciente,
            origen: origenContrato,
            handleChangeOrigen: setOrigenContrato,
            idEvaluacion: idEvaluacion,
            isNew: stateData?.nuevoPaciente,
            idDelegacion: stateData?.idDelegacion,
            codigoDelegacion: stateData?.codigoDelegacion,
            tipoModulo,
            estadosEvolucionAsist,
            nuevoPacienteExistente: stateData?.nuevoPacienteExistente,
            isClientAuthNumeric,
            isClientAuthDigital,
            setIsClientAuthNumeric,
            setIsClientAuthDigital,
            estadosCrediticia,
            setEstadosCrediticia,
            requisitoCliente,
            idPrePaciente: stateData?.idPrePaciente,
            setIsDistinctDelegacion,
            currentStep,
            stateData,
            motivosNoIngreso,
            setMotivosNoIngreso,
            allowedWrite: stateData?.allowedWrite,
            pageLoading,
            setPageLoading,
            refetchGestionPresupuestoRef,
            cambioDireccion,
            setCambioDireccion
          })}
        </TabPanel>
      )}
    </div>);

};